import * as React from 'react';
import { graphql } from 'react-apollo';
import { AnimateOverlay } from 'components/AnimateOverlay';
import MoneyView from 'shared/components/MoneyView';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import * as warningIcon from './static/img/warning.svg';
import { compose } from 'recompose';
import Tooltip from 'shared/components/Tooltip';
import * as query from 'queries/StockPrice/query.gql';
import { responseToProps, StockPriceQuery, StockPriceQueryVariables, Data } from './selectors';

import './styles.scss';

export interface Props {
  stockId: number;
}

type Enhanced = Props & InjectedTranslateProps & Data;

const b = b_.with('stock-top-card-current-price');

const enhance = compose<Enhanced, Props>(
  translate,
  graphql<Props, StockPriceQuery, StockPriceQueryVariables, Data>(query, {
    props: responseToProps,
    options: ({ stockId }) => ({
      variables: { id: stockId },
      pollInterval: 60000, //ms
    }),
  })
);

const CurrentPriceRaw: React.FC<Enhanced> = ({ isPriceAvailable, price, loading, t }) => (
  <AnimateOverlay isVisible={!isPriceAvailable || loading}>
    <Tooltip
      placement="top"
      trigger={isPriceAvailable === false ? ['hover'] : []}
      overlay={
        <div className={`rc-overlay ${b('tooltip')}`}>
          <span className={b('tooltip')}>{t('Cannot get current price short')}</span>
        </div>
      }
    >
      <div className={b('container')}>
        <MoneyView placeholder="-">{price}</MoneyView>
        {isPriceAvailable === false && <img src={warningIcon} className={b('icon')} alt="!" />}
      </div>
    </Tooltip>
  </AnimateOverlay>
);

export const CurrentPrice = enhance(CurrentPriceRaw);
